<script setup lang="ts">
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

const { smallBusinessState } = useSmallBusinessStore();

withDefaults(defineProps<{
  horizontalLayout?: boolean;
}>(), {
  horizontalLayout: false
});
</script>
<template>
  <div class="flex w-full text-normal" :class="{ 'flex-col space-y-2': !horizontalLayout, 'flex-col sm:flex-row space-y-4 sm:space-y-0 sm:justify-between items-start sm:items-center': horizontalLayout }">
    <div class="flex-row">
      <hfc-icon icon="location-dot" class="text-blue-600" />
      <span class="ml-2">{{ smallBusinessState.application.sample_employee.zip_code }}</span>
    </div>
    <div class="flex-row">
      <hfc-icon icon="user" class="text-blue-600" />
      <span class="ml-2">{{ smallBusinessState.application.applicants.length }} Employees</span>
    </div>
  </div>
</template>
